// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payment-wrapper {
  padding: 2rem 1rem;
}

.heading {
  font-size: 2rem;
  font-weight: 600;
  color: #1a1a1a;
}

.download-section {
  text-align: center;
}

.download-qr {
  width: 150px;
  height: auto;
}

.store-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: center;
}

.store-badge {
  width: 160px;
  height: auto;
}

.phone-mockup {
  text-align: center;
  padding: 1rem;
}

.qr-image {
  max-width: 100%;
  height: auto;
}

/* Mobile Specific Styles */
@media (max-width: 768px) {
  .heading {
    font-size: 1.5rem;
    text-align: center;
  }

  h5 {
    font-size: 1rem;
    text-align: center;
  }

  .col-md-6 {
    margin-bottom: 2rem;
  }

  .download-qr {
    width: 120px;
  }

  .store-buttons {
    justify-content: center;
  }

  .phone-mockup {
    padding: 0;
  }

  .qr-image {
    max-width: 80%;
    margin: 0 auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Download.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,cAAc;IACd,cAAc;EAChB;AACF","sourcesContent":[".payment-wrapper {\r\n  padding: 2rem 1rem;\r\n}\r\n\r\n.heading {\r\n  font-size: 2rem;\r\n  font-weight: 600;\r\n  color: #1a1a1a;\r\n}\r\n\r\n.download-section {\r\n  text-align: center;\r\n}\r\n\r\n.download-qr {\r\n  width: 150px;\r\n  height: auto;\r\n}\r\n\r\n.store-buttons {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 1rem;\r\n  justify-content: center;\r\n}\r\n\r\n.store-badge {\r\n  width: 160px;\r\n  height: auto;\r\n}\r\n\r\n.phone-mockup {\r\n  text-align: center;\r\n  padding: 1rem;\r\n}\r\n\r\n.qr-image {\r\n  max-width: 100%;\r\n  height: auto;\r\n}\r\n\r\n/* Mobile Specific Styles */\r\n@media (max-width: 768px) {\r\n  .heading {\r\n    font-size: 1.5rem;\r\n    text-align: center;\r\n  }\r\n\r\n  h5 {\r\n    font-size: 1rem;\r\n    text-align: center;\r\n  }\r\n\r\n  .col-md-6 {\r\n    margin-bottom: 2rem;\r\n  }\r\n\r\n  .download-qr {\r\n    width: 120px;\r\n  }\r\n\r\n  .store-buttons {\r\n    justify-content: center;\r\n  }\r\n\r\n  .phone-mockup {\r\n    padding: 0;\r\n  }\r\n\r\n  .qr-image {\r\n    max-width: 80%;\r\n    margin: 0 auto;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
